import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConfiguracionCorreo;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    error?: kea.FieldError;
    label: string;
}

export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        ClienteSmtp: validation.required,
        Password: validation.required,
        Puerto: validation.required,
        Usuario: validation.required
    }
    return validation.getErrors(rules, x);
}

/**
* Componente auxiliar para mostrar la parte del receptor de las facturas
*/
export class ConfiguracionCorreoNoRX extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    getField = kea.formfields(() => this.props, () => this.errors(this.props));


    render() {
        var { value } = this.props;
        var label = this.props.label;
        const getField = this.getField;

        const Checkbox = getField(kea.Checkbox);
        const Password = getField(kea.Password);
        const Text = getField(kea.Text);
        const Number = getField(kea.Number);

        return (
            <kea.Panel title={label} error={this.props.error} >
                {kea.autogrid(6, [
                    <Text field="ClienteSmtp" label="Cliente SMTP:" />,
                    <Number field="Puerto" label="Puerto:" />,
                    <Text field="Usuario" label="Usuario:" />,
                    <Text field="Password" label="Contraseña:" />,
                    <Checkbox field="EnableSsl" label="Activar SSL:" />,
                ])}
            </kea.Panel>
        );
    }
}

export const ConfiguracionCorreo = componentToRx(ConfiguracionCorreoNoRX);



// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/components/configuracioncorreo.tsx